import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { FlagIcon } from "../../components";
/**
 * Bandeira do país selecionado pelo locale
 * @param {string} locale a ser utilizado
 * @author Fábio Sartori
 * @copyright 06/2019
 */

const country = {
    "pt-br": "br",
    "en-us": "us",
    "es-es": "es",
    pt: "br",
    en: "us",
    br: "br",
    us: "us"
};

const SIZE_DEFAULT = "lg";

class Flag extends PureComponent {
    render() {
        const { locale, size, style } = this.props;
        const flagSize = size ? size : SIZE_DEFAULT;

        return <span style={style}><FlagIcon code={country[locale]} size={flagSize} /></span>;
    }
}

Flag.propTypes = {
    locale: PropTypes.string.isRequired
};
export default Flag;
